import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Stack, Button, Icon, Divider } from 'investira.react.components';
import { Assinar } from '../';
import { ASSINATURA_ESTAGIO } from '../../../enums';

/**
 * Renderiza o componente BulkContextActions.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {boolean} props.disabled - Propriedade `disabled` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const BulkContextActions = memo(props => {
  const { recurso, onDeleteClick, selectedRows, assinatura = false, refreshData } = props;

  const isDisabledDelete = selectedRows?.every(row => {
    return ![ASSINATURA_ESTAGIO.RG.id, null].includes(row.original.assinatura_estagio);
  });
  const isDisabledAssinatura = selectedRows?.every(row => row.original.assinatura_estagio === null);

  return (
    <Stack justifyContent="center" sx={{ height: '40px', marginRight: 2 }} flexGrow={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" flexGrow={1}>
        <Stack direction="row" spacing={2}>
          {onDeleteClick && (
            <Button
              disabled={props.disabled || isDisabledDelete}
              variant="contained"
              color="error"
              startIcon={<Icon iconName="delete" size={16} />}
              size="small"
              sx={{ px: 2 }}
              onClick={() => onDeleteClick(selectedRows)}>
              Excluir
            </Button>
          )}
        </Stack>
        {assinatura && (
          <Assinar
            recurso={recurso}
            disabled={props.disabled || isDisabledAssinatura}
            size="small"
            data={selectedRows.map(xRow => xRow.original)}
            refreshData={refreshData}
          />
        )}
      </Stack>
    </Stack>
  );
});

BulkContextActions.propTypes = {
  disabled: PropTypes.bool
};

export default BulkContextActions;
